export default function ContactSection() {
  return (
    <footer className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-950">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16 md:mb-20">
          <div className="w-10 h-px bg-primary-500/60 mb-6"></div>
          <p className="text-sm tracking-widest uppercase text-background-400 font-label mb-4">
            Contact
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-light text-background-50">
            Get in Touch
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <h3 className="text-xs tracking-widest uppercase text-background-400 font-label mb-4">
              Address
            </h3>
            <address className="not-italic text-sm text-background-200 leading-relaxed font-light space-y-1">
              <p>Gracanska cesta 127c</p>
              <p>Zagreb, 10000</p>
              <p>Croatia</p>
            </address>
          </div>

          <div>
            <h3 className="text-xs tracking-widest uppercase text-background-400 font-label mb-4">
              Phone
            </h3>
            <p className="text-sm text-background-200 font-light">
              +385 97 6079 214
            </p>
          </div>

          <div>
            <h3 className="text-xs tracking-widest uppercase text-background-400 font-label mb-4">
              Email
            </h3>
            <p className="text-sm text-background-200 font-light">
              info@something-digital.com
            </p>
          </div>

          <div>
            <h3 className="text-xs tracking-widest uppercase text-background-400 font-label mb-4">
              Location
            </h3>
            <p className="text-sm text-background-200 font-light">
              Zagreb, Croatia
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-background-800/50">
          <p className="text-xs text-background-500 font-light text-center">
            &copy; {new Date().getFullYear()} Something Digital d.o.o. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}